import 'dom4'
import 'svgxuse'
import domready from 'domready'
import { gsap } from "gsap"
import Swup from 'swup'
import SwupBodyClassPlugin from '@swup/body-class-plugin'
import SwupGaPlugin from '@swup/ga-plugin';
import SwupJsPlugin from '@swup/js-plugin'
import SwupDebugPlugin from '@swup/debug-plugin'
import GlobalHeader from '../global-header'
import PageIntroduction from '../page-introduction'
import Popup from '../popup'
import Accordions from '../accordions'
import WhatWeDoFAQs from '../what-we-do-sections/what-we-do-section-faqs'
import Archive from '../archive'
import InstagramFeed from '../instagram-feed'
import SiteSwitcher from '../site-switcher'
import GlobalFooter from '../global-footer'

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

domready(() => {

  function init() {
    // Initialise PageIntroduction component
    document
      .queryAll('[data-component="page-introduction"]')
      .forEach((element) => {
        new PageIntroduction({
          element,
        });
      });

    // Enable 'touch' class for mobile/tablet devices
    if (touchDevice) {
      document.body.classList.add("touch");
    }

    // Scroll window to top on every page load
    window.scroll({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    // Initialise global header component
    document.queryAll('[data-component="global-header"]').forEach((element) => {
      new GlobalHeader({
        element,
      });
    });

    // Initialise archive component
    document.queryAll('[data-component="archive"]').forEach((element) => {
      new Archive({
        element,
      });
    });

    // Initialise popup component
    document.queryAll('[data-component="popup"]').forEach((element) => {
      new Popup({
        element
      });
    });

    // Initialise global footer component
    document.queryAll('[data-component="global-footer"]').forEach((element) => {
      new GlobalFooter({
        element,
      });
    });

    // Initialise InstagramFeed component
    document
      .queryAll('[data-component="instagram-feed"]')
      .forEach((element) => {
        new InstagramFeed({
          element,
        });
      });

    // Initialise Accordions component
    document.queryAll('[data-component="accordions"]').forEach((element) => {
      new Accordions({
        element,
      });
    });

    // Initialise WhatWeDoFAQs accordions component
    document
      .queryAll('[data-component="what-we-do-section-faqs"]')
      .forEach((element) => {
        new WhatWeDoFAQs({
          element,
        });
      });
  }

  const animationOptions = [
    {
      from: "(.*)",
      to: "(.*)",
      out: (next) => {
        var defaultTransitionOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          visibility: "visible",
          opacity: 1,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 1,
        });
        defaultTransitionOut.play();
      },
      in: (next) => {
        var defaultTransitionIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          visibility: "hidden",
        });
        defaultTransitionIn.play();
      },
    },
    // What we do > What we do subpages
    {
      from: "/what-we-do/",
      to: "/what-we-do(.*)",
      out: (next) => {
        var defaultTransitionOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          visibility: "visible",
          opacity: 1,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 1,
        });
        defaultTransitionOut.play();
      },
      in: (next) => {
        var defaultTransitionIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          visibility: "hidden",
        });
        defaultTransitionIn.play();
      },
    },
    {
      from: "/",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/what-we-do/",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.to("[data-component='mw-transition']", { opacity: 0 });
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/what-we-do(.*)",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/journal(.*)",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/journal(.*)",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/journal/",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/journal(.*)",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/journal(.*)",
      to: "/workshop/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#F0EEEA",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 180,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/workshop/",
      to: "/workshop/faqs-resources/",
      out: (next) => {
        var defaultTransitionOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          visibility: "visible",
          opacity: 1,
        });
        defaultTransitionOut.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 1,
        });
        defaultTransitionOut.play();
      },
      in: (next) => {
        var defaultTransitionIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        defaultTransitionIn.to("[data-component='default-transition']", {
          visibility: "hidden",
        });
        defaultTransitionIn.play();
      },
    },
    {
      from: "/workshop/",
      to: "/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#a55444",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 0,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/workshop/faqs-resources/",
      to: "/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#a55444",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 0,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
    {
      from: "/workshop/book/",
      to: "/",
      out: (next) => {
        var mwTimelineOut = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          backgroundColor: "#a55444",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          opacity: 1,
          visibility: "visible",
        });
        mwTimelineOut.to("[data-component='mw-transition']", {
          duration: 1,
          x: 0,
          y: 0,
          ease: "expo.out",
        });
        mwTimelineOut.to(
          "[data-component='mw-transition'] svg",
          { duration: 0.8, opacity: 1 },
          "+=0.5"
        );
        mwTimelineOut.to(
          "[data-component='mw-transition'] #rotate",
          {
            rotation: 0,
            transformOrigin: "50% 31px",
            ease: "expo.out",
            duration: 1.5,
          },
          "+=0.5"
        );
        mwTimelineOut.play();
      },
      in: (next) => {
        var mwTimelineIn = gsap.timeline({
          repeat: 0,
          repeatDelay: 0,
          paused: true,
          onComplete: next,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          duration: 0.8,
          opacity: 0,
        });
        mwTimelineIn.to("[data-component='mw-transition']", {
          visibility: "hidden",
        });
        mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
        mwTimelineIn.play();
      },
    },
  ];

  // swupOptions
  const swupOptions = {
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupGaPlugin(),
      // new SwupDebugPlugin(),
      new SwupJsPlugin(animationOptions)
    ],
  }

  // Initialise swup
  const swup = new Swup(swupOptions)

  // Initialise global init
  init()

  // Re-initialise JS on page load
  swup.on('contentReplaced', init)

})



// WEBPACK FOOTER //
// ./components/app/index.js